var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/submit text project/gwin/~/._core-js@2.5.0@core-js/modules/_html.js
// module id = ../../../../._core-js@2.5.0@core-js/modules/_html.js
// module chunks = 2